// import React from 'react'

const Display = props => {
  if(!props.if) return null

  return props.children
}

export default Display
